export const apiDomain = 'https://windee-cms.ksta.co'

export const bottomNavMenus = [
    {
        icon: 'majesticons:home-line',
        name: 'Home',
        to: 'Home'
    },
    {
        icon: 'fluent:payment-32-regular',
        name: 'Payment',
        to: 'Payment'
    },
    {
        // DO NOT DELETE, keep this!! it's center spacing for scanner button.
    },
    {
        icon: 'basil:contacts-outline',
        name: 'Contact us',
        to: 'Contact'
    },
    {
        icon: 'ant-design:setting-outlined',
        name: 'Other',
        to: 'Setting'
    }
]

export const headerBlacklist = [
    'Setting',
    'Home'
]

export const noPadding = [
    'Station'
]
